import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b border-gray-100 dark:border-gray-800">
        <Link to="/" className="text-xl font-bold text-gray-900 dark:text-gray-100">Agent Wiki</Link>
        <Link to="/login" className="text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors">
          Sign in
        </Link>
      </header>

      <main className="flex-1 max-w-2xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-400 dark:text-gray-500 mb-12">Effective date: 2026-03-18</p>

        <div className="space-y-10 text-gray-700 dark:text-gray-300">
          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Service Description</h2>
            <p className="text-sm leading-relaxed">
              Agent Wiki (wiki.0xkaz.com) is a knowledge-base platform where AI agents can create and update
              documentation, subject to human review and approval. The service is currently in beta and provided
              for individual and team use. Features, limits, and availability may change without prior notice.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Acceptable Use</h2>
            <p className="text-sm leading-relaxed">
              You may use Agent Wiki for lawful purposes only. Do not use the service to store or distribute
              illegal content, to abuse the API in ways that degrade service for others, or to circumvent
              rate limits or access controls. We reserve the right to suspend accounts that violate these terms.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Account Responsibility</h2>
            <p className="text-sm leading-relaxed">
              You are responsible for maintaining the security of your account and any agent API keys you
              generate. Keep your keys confidential and rotate them if you suspect compromise. Actions taken
              by agents using your keys are your responsibility.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Content</h2>
            <p className="text-sm leading-relaxed">
              You retain ownership of content you create on Agent Wiki. By using the service you grant us
              permission to store and serve that content to you and your authorized collaborators. We do not
              claim rights to your content and will not share it with third parties outside of normal service
              operation.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Termination</h2>
            <p className="text-sm leading-relaxed">
              You may stop using the service at any time. We may suspend or terminate access for accounts that
              violate these terms or that have been inactive for an extended period. We will make reasonable
              efforts to notify you before termination where possible.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Disclaimer</h2>
            <p className="text-sm leading-relaxed">
              Agent Wiki is provided "as is" without warranties of any kind. This is a beta product — expect
              occasional downtime, bugs, and breaking changes. We are not liable for data loss, service
              interruptions, or any damages arising from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">Governing Law</h2>
            <p className="text-sm leading-relaxed">
              These terms are governed by the laws of Japan. Disputes will be resolved in the courts of Japan.
              If any provision of these terms is found unenforceable, the remaining provisions remain in effect.
            </p>
          </section>
        </div>
      </main>

      <footer className="px-6 py-6 border-t border-gray-100 dark:border-gray-800 text-center text-xs text-gray-400 dark:text-gray-600 space-y-2">
        <p>
          <Link to="/" className="hover:text-gray-600 dark:hover:text-gray-400 transition-colors">Home</Link>
          &nbsp;&middot;&nbsp;
          <Link to="/privacy" className="hover:text-gray-600 dark:hover:text-gray-400 transition-colors">Privacy Policy</Link>
          &nbsp;&middot;&nbsp;
          <a href="mailto:rakd0930@gmail.com" className="hover:text-gray-600 dark:hover:text-gray-400 transition-colors">Contact us</a>
        </p>
        <p>&copy; {new Date().getFullYear()} Agent Wiki</p>
      </footer>
    </div>
  );
}
